export const ASSETS = {
  // COMMON: all games have these assets and the ids and paths are the same for all games. Do not alter this section at all
  logos: {
    title: {
      path: 'assets/title.png',
      width: 360,
      height: 190
    },
    playStore: {
      path: 'assets/play_store.png',
      width: 120,
      height: 50
    },
    appStore: {
      path: 'assets/app_store.svg',
      width: 120,
      height: 50
    }
  },
  backgrounds: {
    boxArt: {
      path: 'assets/backgrounds/box_art.png',
      width: 390,
      height: 844
    },
    background: {
      path: 'assets/backgrounds/background.png',
      width: 390,
      height: 844
    },
    gameBackground: {
      path: 'assets/backgrounds/game_background.png',
      width: 390,
      height: 844
    },
    matchmakingBg: {
      path: 'assets/backgrounds/matchmaking_bg.png',
      width: 390,
      height: 844
    },
    lobby_bg: {
      path: 'assets/backgrounds/lobby_bg.png',
      width: 390,
      height: 844
    },
    homeBg: {
      path: 'assets/backgrounds/home_bg.png',
      width: 390,
      height: 844
    }
  }
};
